import {useHref, useLinkClickHandler} from 'react-router-dom';

export const useLinkInButton = (to: string) => {
  const href = useHref(to);
  const onClick = useLinkClickHandler(to);
  return {href, onClick};
};
